import { render, staticRenderFns } from "./ProjectBonus.vue?vue&type=template&id=0f222e94&"
import script from "./ProjectBonus.vue?vue&type=script&lang=js&"
export * from "./ProjectBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports